<!--
  @component
  Generates a hover tooltip. It creates a slot with an exposed variable via `let:detail` that contains information about the event. Use the slot to populate the body of the tooltip using the exposed variable `detail`.
 -->
<script>
    import { fade } from "svelte/transition";

    /** @type {CustomEvent | {}} evt - A svelte event created via [`dispatch`](https://svelte.dev/docs#createEventDispatcher) with event information under `evt.detail.e`. */
    export let evt = {};
    $: onChange(evt);

    export let minWidth = 150;
    export let maxWidth = 262;

    /** @type {Boolean} */
    export let hideTooltip;

    export let placement = "mouse";

    export let style = "normal";

    export let switchToHtmlMap = false;
    let tooltipH = 200;
    let tooltipW = 250;

    let coords = { x: -100, y: -100 };

    let fadeDuration = 200;

    function onChange(evt) {
        if (evt.detail && !hideTooltip) {
            if (placement == "object" && evt.detail.e.srcElement.id) {
                let elem = document.getElementById(evt.detail.e.srcElement.id);
                let bounds = elem.getBoundingClientRect();
                coords["x"] = bounds.right;
                if (coords["x"] + tooltipW > window.innerWidth - 20) {
                    coords["x"] = bounds.left - tooltipW;
                }
                coords["y"] = bounds.bottom;
                if (coords["y"] + tooltipH > window.innerHeight - 20) {
                    coords["y"] = bounds.top - tooltipH;
                }
            } else {
                coords["x"] = evt.detail.e.clientX;
                if (coords["x"] + tooltipW > window.innerWidth - 20) {
                    coords["x"] = coords["x"] - tooltipW;
                }
                coords["y"] = evt.detail.e.clientY;
                if (coords["y"] + tooltipH > window.innerHeight - 20) {
                    coords["y"] = coords["y"] - tooltipH - 30;
                }
            }
        }
    }
</script>

{#if !switchToHtmlMap && evt.detail}
    <div
        bind:clientHeight={tooltipH}
        bind:clientWidth={tooltipW}
        out:fade={{ duration: fadeDuration }}
        class="tooltip {style}"
        style="
      top:{coords['y']}px;
      left:{coords['x']}px;
      max-width:{maxWidth}px;
      min-width:{minWidth}px;
      display:{hideTooltip ? 'none' : 'block'};
    "
    >
        <slot detail={evt.detail} />
    </div>
{/if}

<style lang="scss">
    .tooltip {
        position: fixed;
        // transform: translate(-50%, -100%);
        z-index: 15;
        top: 50%;
        left: 50%;
    }

    .tooltip.normal {
        border-radius: 1px;
        font-size: 13px;
        box-shadow: 0px 0px 5px #e2e2e2;
        border: 1px solid #e2e2e2;
        background: rgba(255, 255, 255, 0.98);
        line-height: var(--line-height-1);
    }
</style>
